import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { getRandomID } from '@mdc/services';
import { SCAN_SANITIZED_STATUS } from '@mdc/constants';

import './DownloadSanitizedButton.scss';

/* eslint-disable camelcase */
const DownloadSanitizedButton = ({ sanitized, downloadSanitized }) => {
    const { t, ready } = useTranslation();

    const [buttonTooltipId] = useState(`ButtonSanitized${getRandomID(5)}`);

    const downloadSanitizedClassName = useMemo(() => classNames({
        'hidden': !sanitized || sanitized.result === SCAN_SANITIZED_STATUS.error || sanitized.file_expired || sanitized.original_data_id,
        'disabled': sanitized?.result !== SCAN_SANITIZED_STATUS.allowed || !sanitized?.file_path
    }, 'downloadSanitizedButton align-middle'), [sanitized]);

    const tooltipDOM = useMemo(() => {
        if (sanitized?.result !== SCAN_SANITIZED_STATUS.allowed || !sanitized?.file_path) {
            return <ReactTooltip id={buttonTooltipId} className='sanitizedToolTip' type='dark' effect="solid" delayHide={300} place={'bottom'}>
                {sanitized?.result === SCAN_SANITIZED_STATUS.blocked ? t('The sanitized file is infected') :
                    sanitized?.result === SCAN_SANITIZED_STATUS.allowed && !sanitized?.file_path ? t('You cannot download the sanitized version because the original file was uploaded by someone else') :
                        t('Available when sanitization finishes')}
            </ReactTooltip>;
        }
    }, [buttonTooltipId, sanitized, t]);

    if (!ready) {
        return null;
    }

    return <>
        <Button
            variant={'link'}
            className={downloadSanitizedClassName}
            onClick={downloadSanitized}
            data-tip
            data-for={buttonTooltipId}
        >
            <i className='icon icon-down'/>
            {t('Sanitized version')}
        </Button>
        {tooltipDOM}
    </>;
};

DownloadSanitizedButton.propTypes = {
    sanitized: PropTypes.object,
    downloadSanitized: PropTypes.func.isRequired
};

export default DownloadSanitizedButton;

